<template>
  <mf-tabs-button v-model="filterType" class="ml-2" size="sm" :buttons="buttons" />
</template>

<script>
export default {
  props: {
    type: String,
  },
  computed: {
    filterType: {
      get() {
        return this.type
      },
      set(value) {
        this.$emit('update:type', value)
      },
    },
    buttons() {
      return [
        {
          id: 0,
          label: 'Mês',
          value: 'mensal',
          active: true,
        },
        {
          id: 1,
          label: 'Semana',
          value: 'semanal',
          active: true,
        },
        {
          id: 1,
          label: 'Dia',
          value: 'diario',
          active: true,
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.filter-type-toggle {
  button {
    height: 24px;
  }
}
</style>
